import { Component, ElementRef, ViewChild, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { HttpClient } from '@angular/common/http';
import { ContextService, LoginData } from '../context.service';
import { MatInput } from '@angular/material/input';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { CaptureFormComponent } from '../dynamic/capture-form/capture-form.component';

@Component({
    selector: 'mutara-field-file',
    templateUrl: './file-type.component.html',
    styleUrl: './file-type.component.scss',
    providers: [{ provide: MatFormFieldControl, useExisting: MutaraFileComponent }],
    standalone: false
})
export class MutaraFileComponent extends FieldType<FieldTypeConfig> implements OnInit, AfterViewInit {
    files: File[] = [];
    currentSelect: string | undefined;
    fileNames: string[] = [];
    baseField: string | undefined;
    isInit: boolean = false;
    childModel: any = {};
    childFields: FormlyFieldConfig[] = [];
    typeSelect: FormControl = new FormControl();
    @ViewChild('fieldModel') fieldModel: MatInput | undefined;
    @ViewChild('fileElement') namedElement: ElementRef<HTMLElement> | undefined;

    constructor(
        private httpClient: HttpClient,
        private contextSettings: ContextService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        super();
        this.isInit = true;
    }
    get debug(): boolean {
        return this.props?.capForm?.debug;
    }
    /**
     * Watch the list of select options
     */
    ngOnInit(): void {
        let _valueToSet = this.props.getValue();
        this.formControl.setValue(_valueToSet);
        // This is how we make other uploads "know"
        this.contextSettings.subscribeTo("fileSaved", ( (fileInfo : any) => {
            if (fileInfo?.type == this.props.fileType && !!fileInfo) {
                this.currentSelect = fileInfo?.selected;
                this.fileNames = fileInfo?.file;
                // These are deferred until now so the UI can catch up
                this.props.setValue(this.value, true);
                this.changeDetectorRef.markForCheck();
            }
        }));

        this.baseField = (<string>this.key).split('-')[0] + '-extra';
        // this.childModel[this.baseField] = {};
        this.typeSelect.valueChanges.subscribe(value => {
            if (!this.isInit) {
                this._clearChildData();
            } else {
                this.isInit = false;
            }
            this.formControl.setValue(this.value);
        });
        let fileNames, value;
        try {
            value = (_valueToSet ?? '|')?.split('|');
            this.currentSelect = value[0] ?? '';
            this.typeSelect.setValue(this.currentSelect);
            try {
                fileNames = JSON.parse(value[1]);
            } catch (err) {
                fileNames = value[1] != '' ? [value[1]] : [];
            }
            if (!!this.props?.dataToCollect) {
                this.props?.dataToCollect?.forEach( (childField :any)=> {
                    //    let validate = Object.entries(childField.validation);

                    if (childField?.displayLogic) {
                        childField.displayFunction = new Function(childField.displayLogic);
                    }
                    this.childFields.push({
                        key: childField.fieldName,
                        type: childField.type,
                        className: 'flex-1',
                        modelOptions: { updateOn: 'blur' },
                        defaultValue: this.formState.data[this.props.stepName][childField.fieldName],
                        expressions: {
                            hide: (fc: FormlyFieldConfig) => !this._isChildVisible(fc.props?.sourceDefn)
                        },
                        props: {
                            label: childField.label,
                            description: childField?.hint ?? '',
                            required: childField.required,
                            sourceDefn: childField
                        }
                    });
                    this.childModel[childField.fieldName] = this.formState.data[this.props.stepName][childField.fieldName];
                });
            }
        } catch (e) {
            console.error('Error %O ngOnInit.MutaraFileComponent %O', this.key, e);
        }

        this.fileNames = fileNames ?? [];
    }
    ngAfterViewInit() {
        this.checkErrors();
        if (this.hasExtraFields && this.childFields[0].form ) {
            this.childFields[0].form.statusChanges.subscribe({
                next: () => {
                    this.checkErrors();
                }
            });
        }
    }

    checkErrors() {
        let errors = null, prevErrors = this.formControl.errors;
        if (this.props.required) {
            if (this.hasOptions && this.currentSelect == '') {
                errors = Object.assign(errors ?? {}, { selectType: 'Please select a file type for ' + this.props.label });
            }
            if (this.fileNames.length == 0) {
                errors = Object.assign(errors ?? {}, { selectFile: 'Please select a file to upload for ' + this.props.label });
            }
            if (this.hasExtraFields && this.childFields[0].form?.invalid) {
                errors = Object.assign(errors ?? {}, { childValues: 'Please enter the data about the file for ' + this.props.label });
            }
        }
        if (errors != prevErrors) {
            this.formControl.setErrors(errors, { emitEvent: true });
        }
    }
    /**
     * Force the hidden field to get the file
     * @param 
     */
    triggerHiddenUploadClick() {
        if (!this.disableButton) {
            this.namedElement?.nativeElement.click();
        }
    }
    get capForm(): CaptureFormComponent {
        return this.props.capForm;
    }

    get lstOptions(): any[] {
        return <any[]>this.props.options;
    }
    get disableButton(): boolean {
        return ((this.fileNames?.length ?? 0) > 0 || (!!this.hasOptions && !this.currentSelect));
    }
    get hasOptions(): boolean {
        return ((<any[]>this.props?.options)?.length ?? 0) > 0;
    }
    get hasExtraFields(): boolean {
        return (this.props?.dataToCollect?.length ?? 0) > 0;
    }
    get value() {
        return `${(this.currentSelect ?? '')}|${JSON.stringify(this.fileNames) ?? ''}`;
    }
    _clearChildData() {
        this.props?.dataToCollect?.forEach( (childField : any ) => {
            this.childModel[childField.id] = null;
        });
    }

    _isChildVisible(childDefn : any): boolean {
        let visible = this.currentSelect != '';
        try {
            visible = childDefn?.displayFunction?.call(this) ?? visible;
        } catch (err) {
            console.error('Execution of displayLogic error %O', err);
        }
        return visible;
    }

    _submitChildValues(values = this.childModel) {
        // Find the deferred data for this record and add any special fields (ex: saveField)
        let deferred = this.capForm.__getDeferredRecord(this.props.recordName), keys = this.capForm.recordKeyMap[this.props.recordName];
        // Here we can look for values to stash in the deferred values.... 
        // This should only update unchanged values (this field, not related deferred)
        let fullDataKey = this.props.decoratedId.split('-')[0] + '-extra.';
        this.props?.dataToCollect?.forEach( (child : any) => {
            deferred[fullDataKey + child.id] = values[this.baseField ?? ''][child.id];
        });
        // Now we can return what we know  
        let dataToSend = {
            formName: this.props.stepName,
            data: {
                type: 'update',
                record: this.props.recordName,
                keys: keys,
                values: deferred
            }
        };

        this.capForm._deferredChanges.next(dataToSend);
    }
    onChange(event: any) {
        let files: File[] = Array.from(event.target.files);
        if (files.length > 0) {
            this._sendFileData('store', files);
        }
    }

    deleteFile() {
        this._sendFileData('delete', [this.props.fileType]);
    }
    _sendFileData(action: string, files: File[]) {
        try {
            let formParams = new FormData();
            formParams.append('selected', this.currentSelect ?? '');
            formParams.append('target', this.props.uploadTo);
            formParams.append('type', this.props.fileType + (this.props?.rowNumber ?? ''));
            formParams.append('action', action);

            files.forEach(fileData => {
                formParams.append('file', fileData);
            });
            this.httpClient.post(`$service/${this.props.uploadTo == 'Grooper' ? 'process-document' : 'doc-upload'}`, formParams).subscribe({
                error: (err) => {
                    console.error('file upload failed %O', err);
                },
                next: (result: any) => {
                    switch (result.action) {
                        case 'redirect':
                            let login = <LoginData>result.user;
                            this.contextSettings.setLoginData(login);
                            // The login data change lazily, so send what we know to get us loggged in
                            this.contextSettings.setLayoutId(result.defaultLayout);
                            break;
                    }
                    this.fileNames = result?.success?.map( (fileData : any) => fileData?.fileName ?? '');
                    this.contextSettings.nextMessage("fileSaved", { type: this.props.fileType, file: this.fileNames, selected: this.currentSelect ?? '' });
                    if (this.props.row != -1) {
                        this.props.row == -1;
                    }
                }
            });
        } catch (e) {
            console.error('File upload error: %O', e);
        }
    }
}

